import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';

import { IStateApiResponse } from '../models/state';

@Injectable({
  providedIn: 'root'
})
export class StatesServedHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ){}

  listStates$(): Observable<IAPIListResponse<string>> {
    const opts: Partial<IAPIListRequestOptions> = {
      page: 'disabled',
      filter: [
        { key: 'available_providers', value: 'true' }
      ]
    };
    const params = this.http.generateListParams(opts);

    return this.http
      .get<IAPIListResponse<IStateApiResponse>>(this.fetchUrlStates, params)
      .pipe(
        map((response: IAPIListResponse<IStateApiResponse>) => (
          {
            ...response,
            data: response.data.map((state) => state.network_state)
          }
        )),
        this.http.handleHttpErrorStrict()
      );
  }

  get fetchUrlStates(): string {
    return `${this.configurationService.env.svcBase}/billing/provider_network_company_states`;
  }
}
